const t = {
  name: "CheckmarkSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.4144 8.00015L18.0002 6.58594L10.0002 14.5859L6.00015 10.5859L4.58594 12.0002L10.0002 17.4144L19.4144 8.00015Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CheckmarkSmall
};
